export const FilterFormatter = {
  "searchTag": "Keyword",
  "contractStatus": "Contract Status",
  "openerId": "Opener",
  "ownerId": "Owner",
  "closerId": "Closer",
  "countryCode": "Country"
}